import React from 'react';
import { Chip } from "@mui/material";

// El chip que marca la dirección principal de un cliente. Va compacto a
// propósito: con el tamaño por defecto de MUI empuja la dirección a dos líneas
// y termina tapándola. Se usa en Clientes y en los diálogos que hacen elegir
// entre las direcciones de un pedido, así que vive acá y no como sx inline.
const PrimaryAddressChip = () => (
    <Chip
        size="small"
        color="error"
        label="Principal"
        sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
    />
);

export default PrimaryAddressChip;
